import { render, staticRenderFns } from "./SdsTableSection2GHS.vue?vue&type=template&id=f6242c6e"
import script from "./SdsTableSection2GHS.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection2GHS.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsTableSection2GHS.vue?vue&type=style&index=0&id=f6242c6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports